import React from 'react';
import Swal from "sweetalert2";
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import PasswordField from '@/shared/components/form/Password';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const default_user_avatar = "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_640.png"

const NewUser = () => {
  const submitNewUser = (values) => {
    values['picture'] = default_user_avatar;
    let newUser = JSON.stringify(values)
    AdminInterface.instance.createUser(newUser).then(() => {
      withReactContent(Swal).fire({
        title: "Success",
        html: "New user is created!",
      });
     }).catch((error) => {
      withReactContent(Swal).fire({
        title: "Error",
        html: error.response.data.detail,
      });
     });
  }

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <CardTitleWrap>
            <CardTitle>New Freemium User</CardTitle>
          </CardTitleWrap>
          <Form onSubmit={submitNewUser}>
            {({ handleSubmit, form }) => (
              <FormContainer horizontal onSubmit={handleSubmit}>
                <FormGroup>
                  <FormGroupLabel>First Name</FormGroupLabel>
                  <FormGroupField>
                    <Field name="given_name" component="input" type="text" placeholder="firstname"/>
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Last Name</FormGroupLabel>
                  <FormGroupField>
                    <Field name="family_name" component="input" type="text" placeholder="lastname"/>
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>E-mail</FormGroupLabel>
                  <FormGroupField>
                    <Field name="email" component="input" type="email" placeholder="example@mail.com"/>
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Password</FormGroupLabel>
                  <FormGroupField>
                    <Field name="password" component={PasswordField} placeholder="Password"/>
                  </FormGroupField>
                </FormGroup>
                <FormButtonToolbar>
                  <Button variant="primary" type="submit">Submit</Button>
                  <Button variant="secondary" type="button" onClick={form.reset}>
                    Cancel
                  </Button>
                </FormButtonToolbar>
              </FormContainer>
            )}          
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

NewUser.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default NewUser;
